export default __webpack_public_path__ + "static/media/Ocean reef3.8b826ec7.jpg";